/**
 * 记录本端刚更新的 todo id，供 Realtime 回调去重，避免同一变更触发两次数据刷新。
 */
let lastId: string | null = null;
let lastAt = 0;
const TTL_MS = 15000; // 覆盖网络延迟与 Realtime 广播延迟，避免本端更新被覆盖导致回滚

export function markTodoUpdatedByUs(id: string): void {
  lastId = id;
  lastAt = Date.now();
}

export function wasTodoJustUpdatedByUs(id: string): boolean {
  return lastId === id && Date.now() - lastAt < TTL_MS;
}

/** 本端最近是否有更新（任意 todo），供 Realtime 判断是否跳过处理 */
export function wasAnyTodoRecentlyUpdatedByUs(): boolean {
  return Date.now() - lastAt < TTL_MS;
}
